// Mortgage maths (UK repayment mortgage)
export const monthlyRepayment = (principal, annualRate, termYears) => {
  if (!principal || principal <= 0 || !termYears) return 0;
  const r = annualRate / 100 / 12;
  const n = termYears * 12;
  if (r === 0) return principal / n;
  return (principal * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
};

export const fmtGBP = (n) => {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 0,
  }).format(n);
};

export const fmtPct = (n, digits = 1) => `${(n || 0).toFixed(digits)}%`;

// Returns total interest and months to clear given optional monthly overpayment.
export const amortise = (principal, annualRate, termYears, overpayment = 0) => {
  let balance = principal;
  const r = annualRate / 100 / 12;
  const baseMonthly = monthlyRepayment(principal, annualRate, termYears);
  const payment = baseMonthly + (overpayment || 0);
  let months = 0;
  let totalInterest = 0;
  const maxMonths = termYears * 12;
  while (balance > 0 && months < maxMonths * 2) {
    const interest = balance * r;
    const principalPaid = Math.min(payment - interest, balance);
    if (principalPaid <= 0) break;
    balance -= principalPaid;
    totalInterest += interest;
    months += 1;
  }
  return {
    monthlyPayment: payment,
    baseMonthly,
    totalInterest,
    totalRepaid: principal + totalInterest,
    monthsToClear: months,
    yearsToClear: months / 12,
  };
};
